<template>    
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="questions && !loading" :class="{'py-4 px-0': phoneOnly, 'py-6': pcOnly}">
                <div class="mb-6 px-4 px-lg-0 d-flex align-center justify-space-between">
                    <h3 v-if="pcOnly" class="font-weight-medium me-3">أسئلتي</h3>
                    <v-btn color="primary" :block="phoneOnly" depressed rounded @click="createDialog = true;">
                        <v-icon size="23" left>mdi-file-plus-outline</v-icon>
                        <span>الاستفسار عن سؤال</span>
                    </v-btn>
                </div>
                <v-list v-if="questions && questions.length" class="py-0">
                    <template v-for="question in questions">
                        <bank-question-list-item :question="question" :key="question.id" />
                        <v-divider inset :key="'divider-' + question.id" style="opacity: 0.6"></v-divider>
                    </template>
                </v-list>

                <div v-else class="pa-4 pa-lg-0">
                    <v-alert type="info" color="blue-grey" text class="mb-0">
                        <div class="details-text">لم تقم بالاستفسار عن أي أسئلة حتى الآن.</div>
                    </v-alert>
                </div>


            </v-container>
        </transition>
        <v-dialog v-model="createDialog" max-width="500" overlay-color="#000">
            <v-card>
                <v-card-title>الاستفسار عن سؤال</v-card-title>
                <v-card-text class="mt-4">
                    <v-form ref="form">
                        <v-textarea v-model="text" outlined label="نص السؤال" :disabled="creating" no-resize rows="3"></v-textarea>
                        <v-file-input v-model="image" outlined label="صورة السؤال" accept="image/*" :disabled="creating" prepend-icon="" prepend-inner-icon="mdi-image" ></v-file-input>

                        <v-autocomplete v-model="category" chips label="اختر تصنيف السؤال" outlined :items="categoriesSelectItems" :menu-props="{ dense: true }" :disabled="creating">
                            <template v-slot:selection="{ item }">
                                <v-chip color="primary" small label>
                                    <span v-if="item.text.split('/').length > 1" style="opacity: 0.6">{{item.text.split('/')[0]}} / </span>
                                    <span class="ms-1">{{item.text.split('/')[item.text.split('/').length-1]}}</span>
                                </v-chip>
                            </template>
                        </v-autocomplete>

                        <v-select v-if="requireTeacher" v-model="teacherId" outlined label="المدرس" no-data-text="ليس لديك صلاحية سؤال مدرس من المدرسين" placeholder="اختر المدرس" :items="teachersSelectItems" :menu-props="{ offsetY: true, dense: true }" :disabled="creating"></v-select>


                        <v-text-field v-model="pageNumber" outlined label="رقم الصفحة" :disabled="creating" placeholder="رقم الصفحة التي ورد فيها السؤال" type="number" min="1"></v-text-field>
                        <v-text-field v-model="questionNumber" outlined label="رقم السؤال" :disabled="creating" placeholder="رقم السؤال" type="number" min="1"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="createDialog = false">إلغاء</v-btn>
                <v-btn color="primary" :loading="creating" text @click="submit">تأكيد</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import BankQuestionListItem from '@/components/custom/bank-question-list-item'

export default {
    name: "MyQuestions",
    components: {
        BankQuestionListItem
    },
    props: {

    },
    data(){
        return {
            questions: null,
            categories: null,
            teachers: [],
            requireTeacher: false,

            createDialog: false,
            
            text: '',
            image: null,
            pageNumber: '',
            questionNumber: '',
            category: '',
            teacherId: '',

            loading: false,
            creating: false,
        }
    },
    computed: {
        ...GlobalComputed,
        categoriesSelectItems(){
            if (this.categories){
                return this.categories.map(category=>{
                    return {text: category.full_path, value: category.id}
                })
            }else{
                return [];
            }
        },
        teachersSelectItems(){
            return (this.teachers || []).map(teacher => {
                return {text: teacher.name, value: teacher.id}
            });
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        openingExam(loading){
            this.setLinearLoading(loading);
        }
    },
    methods: {
        ...GlobalMethods,
        getData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('fastGetAction', {url: '/bank-questions/categories'}).then(res=>{
                    this.categories = res.data.data;

                    this.$store.dispatch('fastGetAction', {url: '/bank-questions/my-questions'}).then(response=>{
                        this.loading = false;
                        this.questions = response.data.data;
                        this.requireTeacher = !!response.data.require_teacher;
                        this.teachers = response.data.teachers || [];

    
                    }).catch(()=>{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                        this.loading = false;
                    });
                }).catch(e=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });

            }
        },
        submit(){
            
            if (!this.creating){
                this.creating = true;
                
                let formData = new FormData();
                if (this.image){
                    formData.append('image', this.image);
                }
                if (this.text){
                    formData.append('text', this.text);
                }
                formData.append('page_number', this.pageNumber);
                formData.append('question_number', this.questionNumber);
                formData.append('bank_question_category_id', this.category);
                if (this.requireTeacher && this.teacherId){
                    formData.append('teacher_id', this.teacherId);
                }

                this.$store.dispatch('fastPostAction', {url: '/bank-questions', data: formData, headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
                    this.showMsg('تم إرسال السؤال بنجاح', 'success');
                    this.$refs.form.reset();
                    this.teacherId = '';
                    this.creating = false;
                    this.createDialog = false;

                    const question = response.data.data;
                    if (!this.questions) this.questions = [];
                    this.questions.unshift(question);

                }).catch((error)=>{
                    if (error.response && error.response.status === 422){
                        // coming errors from backend
                        let errors = error.response.data.errors;
                        this.showMsg(errors[Object.keys(errors)[0]][0]);
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تنفيذ الطلب', 'error');
                    }

                    this.creating = false;
                });
            }
        }
    },
    mounted(){
        this.getData();
    }
};
</script>